import {ModalType} from "../models/custom/enums/modalType";
import {OfferTDRB} from "../models/custom/offerTDRB";
import {PaymentSuccessHRTD} from "../models/custom/paymentSuccessHRTD";
import {OfferType} from "../models/enums/offerType";

export default class ContentKeys {

  static PLACEHOLDER: string = 'PLACEHOLDER';

  // EVENTS
  static INIT_EVENT: string = 'init_event'; // http://yaani.kazan-kazan.com/?init_event=google_ekim_event
  static INIT_EVENT_VALUES: string = 'INIT_EVENT_VALUES'; // |google_ekim_event|google_kasim_event|facebook_event|facebook_agustos_event|
  static INIT_EVENT_VALUES_SEPARATOR: string = '|';

  // TEXT
  static MENU_MY_ACCOUNT_TAB: string = 'MENU_MY_ACCOUNT_TAB';
  static MENU_LOGIN_TAB: string = 'MENU_LOGIN_TAB';
  static MENU_HOW_TO_PLAY_TAB: string = 'MENU_HOW_TO_PLAY_TAB';
  static MENU_FAQ_TAB: string = 'MENU_FAQ_TAB';
  static MENU_TERMS_AND_CONDITIONS_TAB: string = 'MENU_TERMS_AND_CONDITIONS_TAB';
  static MENU_CONTACT_TAB: string = 'MENU_CONTACT_TAB';
  static MENU_LOGOUT_TAB: string = 'MENU_LOGOUT_TAB';
  static MY_ACCOUNT_TITLE: string = 'MY_ACCOUNT_TITLE';
  static HOW_TO_PLAY_POPUP_TITLE: string = 'HOW_TO_PLAY_POPUP_TITLE';
  static HOW_TO_PLAY_POPUP_TEXT: string = 'HOW_TO_PLAY_POPUP_TEXT';
  static FAQ_POPUP_TITLE: string = 'FAQ_POPUP_TITLE';
  static FAQ_POPUP_TEXT: string = 'FAQ_POPUP_TEXT';
  static TERMS_AND_CONDITIONS_TITLE: string = 'TERMS_AND_CONDITIONS_TITLE';
  static TERMS_AND_CONDITIONS_TEXT: string = 'TERMS_AND_CONDITIONS_TEXT';
  static CONTACT_POPUP_TITLE: string = 'CONTACT_POPUP_TITLE';
  static CONTACT_SUBJECTS: string = 'CONTACT_SUBJECTS';
  static LOGOUT_POPUP_TITLE: string = 'LOGOUT_POPUP_TITLE';
  static LOGOUT_POPUP_TEXT: string = 'LOGOUT_POPUP_TEXT';
  static HOME_HEADER: string = 'HOME_HEADER';
  static HOME_PLAY_BUTTON: string = 'HOME_PLAY_BUTTON';
  static HOMEPAGE_TITLE: string = 'HOMEPAGE_TITLE';
  static HOMEPAGE_TEXT: string = 'HOMEPAGE_TEXT';
  static HOMEPAGE_START_BUTTON: string = 'HOMEPAGE_START_BUTTON';
  static BUTTON_GIFT: string = 'BUTTON_GIFT';
  static MOBILE_CONNECT_POPUP_TITLE: string = 'MOBILE_CONNECT_POPUP_TITLE';
  static MOBILE_CONNECT_POPUP_TEXT: string = 'MOBILE_CONNECT_POPUP_TEXT';
  static MOBILE_CONNECT_POPUP_BUTTON: string = 'MOBILE_CONNECT_POPUP_BUTTON';
  static MODAL_SESSION_ERROR_TITLE: string = 'MODAL_SESSION_ERROR_TITLE';
  static MODAL_SESSION_ERROR_BUTTON: string = 'MODAL_SESSION_ERROR_BUTTON';
  static MODAL_SMS_TITLE: string = 'MODAL_SMS_TITLE';
  static MODAL_SMS_TEXT: string = 'MODAL_SMS_TEXT';
  static MODAL_SMS_BUTTON: string = 'MODAL_SMS_BUTTON';
  static MODAL_SMS_WRONG_TITLE: string = 'MODAL_SMS_WRONG_TITLE';
  static MODAL_SMS_WRONG_TEXT: string = 'MODAL_SMS_WRONG_TEXT';
  static MODAL_SMS_WRONG_BUTTON: string = 'MODAL_SMS_WRONG_BUTTON';

  static NEWCOMER_TITLE: string = 'NEWCOMER_TITLE';
  static NEWCOMER_DESC: string = 'NEWCOMER_DESC';
  static NEWCOMER_BUTTON: string = 'NEWCOMER_BUTTON';

  static NEW_GAME_HEADER: string = 'NEW_GAME_HEADER';
  static NEW_GAME_TITLE: string = 'NEW_GAME_TITLE';
  static NEW_GAME_P2S_DESC: string = 'NEW_GAME_P2S_DESC';
  static NEW_GAME_P2S_BUTTON: string = 'NEW_GAME_P2S_BUTTON';
  static NEW_GAME_J2F_S_DESC: string = 'NEW_GAME_J2F_S_DESC';
  static NEW_GAME_J2F_S_BUTTON: string = 'NEW_GAME_J2F_S_BUTTON';

  static CONTACT_MAIL_TITLE: string = 'CONTACT_MAIL_TITLE';
  static CONTACT_MAIL_PH: string = 'CONTACT_MAIL_PH';
  static CONTACT_SUBJECT_TITLE: string = 'CONTACT_SUBJECT_TITLE';
  static CONTACT_SUBJECT_PH: string = 'CONTACT_SUBJECT_PH';
  static CONTACT_MESSAGE_TITLE: string = 'CONTACT_MESSAGE_TITLE';
  static CONTACT_MESSAGE_PH: string = 'CONTACT_MESSAGE_PH';
  static CONTACT_BUTTON: string = 'CONTACT_BUTTON';
  static CONTACT_SUCCESFUL_MESSAGE: string = 'CONTACT_SUCCESFUL_MESSAGE';
  static CONTACT_SUCCESFUL_BUTTON: string = 'CONTACT_SUCCESFUL_BUTTON';

  static DESICION_HEADER: string = 'DESICION_HEADER';
  static DESICION_TITLE: string = 'DESICION_TITLE';
  static DESICION_CONTINUE_DESC: string = 'DESICION_CONTINUE_DESC';
  static DESICION_CONTINUE_BUTTON: string = 'DESICION_CONTINUE_BUTTON';
  static DESICION_J2F_DESC: string = 'DESICION_J2F_DESC';
  static DESICION_J2F_BUTTON: string = 'DESICION_J2F_BUTTON';
  static DESICION_GIVE_UP_BUTTON: string = 'DESICION_GIVE_UP_BUTTON';

  static WRONG_ANSWER_LEVEL_1_HEADER: string = 'WRONG_ANSWER_LEVEL_1_HEADER';
  static WRONG_ANSWER_LEVEL_1_DESC: string = 'WRONG_ANSWER_LEVEL_1_DESC';
  static WRONG_ANSWER_LEVEL_1_P2C_DESC: string = 'WRONG_ANSWER_LEVEL_1_P2C_DESC';
  static WRONG_ANSWER_LEVEL_1_P2C_BUTTON: string = 'WRONG_ANSWER_LEVEL_1_P2C_BUTTON';
  static WRONG_ANSWER_LEVEL_1_J2F_DESC: string = 'WRONG_ANSWER_LEVEL_1_J2F_DESC';
  static WRONG_ANSWER_LEVEL_1_J2F_BUTTON: string = 'WRONG_ANSWER_LEVEL_1_J2F_BUTTON';
  static WRONG_ANSWER_LEVEL_2_HEADER: string = 'WRONG_ANSWER_LEVEL_2_HEADER';
  static WRONG_ANSWER_LEVEL_2_DESC: string = 'WRONG_ANSWER_LEVEL_2_DESC';
  static WRONG_ANSWER_LEVEL_2_P2C_DESC: string = 'WRONG_ANSWER_LEVEL_2_P2C_DESC';
  static WRONG_ANSWER_LEVEL_2_P2C_BUTTON: string = 'WRONG_ANSWER_LEVEL_2_P2C_BUTTON';
  static WRONG_ANSWER_LEVEL_2_J2F_DESC: string = 'WRONG_ANSWER_LEVEL_2_J2F_DESC';
  static WRONG_ANSWER_LEVEL_2_J2F_BUTTON: string = 'WRONG_ANSWER_LEVEL_2_J2F_BUTTON';
  static WRONG_ANSWER_LEVEL_3_HEADER: string = 'WRONG_ANSWER_LEVEL_3_HEADER';
  static WRONG_ANSWER_LEVEL_3_DESC: string = 'WRONG_ANSWER_LEVEL_3_DESC';
  static WRONG_ANSWER_LEVEL_3_P2C_DESC: string = 'WRONG_ANSWER_LEVEL_3_P2C_DESC';
  static WRONG_ANSWER_LEVEL_3_P2C_BUTTON: string = 'WRONG_ANSWER_LEVEL_3_P2C_BUTTON';
  static WRONG_ANSWER_LEVEL_3_J2F_DESC: string = 'WRONG_ANSWER_LEVEL_3_J2F_DESC';
  static WRONG_ANSWER_LEVEL_3_J2F_BUTTON: string = 'WRONG_ANSWER_LEVEL_3_J2F_BUTTON';
  static WRONG_ANSWER_LEVEL_4_HEADER: string = 'WRONG_ANSWER_LEVEL_4_HEADER';
  static WRONG_ANSWER_LEVEL_4_DESC: string = 'WRONG_ANSWER_LEVEL_4_DESC';
  static WRONG_ANSWER_LEVEL_4_P2C_DESC: string = 'WRONG_ANSWER_LEVEL_4_P2C_DESC';
  static WRONG_ANSWER_LEVEL_4_P2C_BUTTON: string = 'WRONG_ANSWER_LEVEL_4_P2C_BUTTON';
  static WRONG_ANSWER_LEVEL_4_J2F_DESC: string = 'WRONG_ANSWER_LEVEL_4_J2F_DESC';
  static WRONG_ANSWER_LEVEL_4_J2F_BUTTON: string = 'WRONG_ANSWER_LEVEL_4_J2F_BUTTON';
  static WRONG_ANSWER_LEVEL_5_HEADER: string = 'WRONG_ANSWER_LEVEL_5_HEADER';
  static WRONG_ANSWER_LEVEL_5_DESC: string = 'WRONG_ANSWER_LEVEL_5_DESC';
  static WRONG_ANSWER_LEVEL_5_P2C_DESC: string = 'WRONG_ANSWER_LEVEL_5_P2C_DESC';
  static WRONG_ANSWER_LEVEL_5_P2C_BUTTON: string = 'WRONG_ANSWER_LEVEL_5_P2C_BUTTON';

  static TIME_EXPIRED_LEVEL_1_HEADER: string = 'TIME_EXPIRED_LEVEL_1_HEADER';
  static TIME_EXPIRED_LEVEL_1_DESC: string = 'TIME_EXPIRED_LEVEL_1_DESC';
  static TIME_EXPIRED_LEVEL_1_P2C_DESC: string = 'TIME_EXPIRED_LEVEL_1_P2C_DESC';
  static TIME_EXPIRED_LEVEL_1_P2C_BUTTON: string = 'TIME_EXPIRED_LEVEL_1_P2C_BUTTON';
  static TIME_EXPIRED_LEVEL_1_J2F_DESC: string = 'TIME_EXPIRED_LEVEL_1_J2F_DESC';
  static TIME_EXPIRED_LEVEL_1_J2F_BUTTON: string = 'TIME_EXPIRED_LEVEL_1_J2F_BUTTON';
  static TIME_EXPIRED_LEVEL_2_HEADER: string = 'TIME_EXPIRED_LEVEL_2_HEADER';
  static TIME_EXPIRED_LEVEL_2_DESC: string = 'TIME_EXPIRED_LEVEL_2_DESC';
  static TIME_EXPIRED_LEVEL_2_P2C_DESC: string = 'TIME_EXPIRED_LEVEL_2_P2C_DESC';
  static TIME_EXPIRED_LEVEL_2_P2C_BUTTON: string = 'TIME_EXPIRED_LEVEL_2_P2C_BUTTON';
  static TIME_EXPIRED_LEVEL_2_J2F_DESC: string = 'TIME_EXPIRED_LEVEL_2_J2F_DESC';
  static TIME_EXPIRED_LEVEL_2_J2F_BUTTON: string = 'TIME_EXPIRED_LEVEL_2_J2F_BUTTON';
  static TIME_EXPIRED_LEVEL_3_HEADER: string = 'TIME_EXPIRED_LEVEL_3_HEADER';
  static TIME_EXPIRED_LEVEL_3_DESC: string = 'TIME_EXPIRED_LEVEL_3_DESC';
  static TIME_EXPIRED_LEVEL_3_P2C_DESC: string = 'TIME_EXPIRED_LEVEL_3_P2C_DESC';
  static TIME_EXPIRED_LEVEL_3_P2C_BUTTON: string = 'TIME_EXPIRED_LEVEL_3_P2C_BUTTON';
  static TIME_EXPIRED_LEVEL_3_J2F_DESC: string = 'TIME_EXPIRED_LEVEL_3_J2F_DESC';
  static TIME_EXPIRED_LEVEL_3_J2F_BUTTON: string = 'TIME_EXPIRED_LEVEL_3_J2F_BUTTON';
  static TIME_EXPIRED_LEVEL_4_HEADER: string = 'TIME_EXPIRED_LEVEL_4_HEADER';
  static TIME_EXPIRED_LEVEL_4_DESC: string = 'TIME_EXPIRED_LEVEL_4_DESC';
  static TIME_EXPIRED_LEVEL_4_P2C_DESC: string = 'TIME_EXPIRED_LEVEL_4_P2C_DESC';
  static TIME_EXPIRED_LEVEL_4_P2C_BUTTON: string = 'TIME_EXPIRED_LEVEL_4_P2C_BUTTON';
  static TIME_EXPIRED_LEVEL_4_J2F_DESC: string = 'TIME_EXPIRED_LEVEL_4_J2F_DESC';
  static TIME_EXPIRED_LEVEL_4_J2F_BUTTON: string = 'TIME_EXPIRED_LEVEL_4_J2F_BUTTON';
  static TIME_EXPIRED_LEVEL_5_HEADER: string = 'TIME_EXPIRED_LEVEL_5_HEADER';
  static TIME_EXPIRED_LEVEL_5_DESC: string = 'TIME_EXPIRED_LEVEL_5_DESC';
  static TIME_EXPIRED_LEVEL_5_P2C_DESC: string = 'TIME_EXPIRED_LEVEL_5_P2C_DESC';
  static TIME_EXPIRED_LEVEL_5_P2C_BUTTON: string = 'TIME_EXPIRED_LEVEL_5_P2C_BUTTON';

  static TERMS_AND_COND_LINK: string = 'TERMS_AND_COND_LINK';
  static TERMS_AND_COND_TEXT: string = 'TERMS_AND_COND_TEXT';

  static OFFER_P2C_1_TITLE: string = 'OFFER_P2C_1_TITLE';
  static OFFER_P2C_1_DESC: string = 'OFFER_P2C_1_DESC';
  static OFFER_P2C_1_BUTTON: string = 'OFFER_P2C_1_BUTTON';
  static OFFER_P2C_2_TITLE: string = 'OFFER_P2C_2_TITLE';
  static OFFER_P2C_2_DESC: string = 'OFFER_P2C_2_DESC';
  static OFFER_P2C_2_BUTTON: string = 'OFFER_P2C_2_BUTTON';
  static OFFER_P2C_3_TITLE: string = 'OFFER_P2C_3_TITLE';
  static OFFER_P2C_3_DESC: string = 'OFFER_P2C_3_DESC';
  static OFFER_P2C_3_BUTTON: string = 'OFFER_P2C_3_BUTTON';
  static OFFER_P2C_4_TITLE: string = 'OFFER_P2C_4_TITLE';
  static OFFER_P2C_4_DESC: string = 'OFFER_P2C_4_DESC';
  static OFFER_P2C_4_BUTTON: string = 'OFFER_P2C_4_BUTTON';
  static OFFER_P2C_5_TITLE: string = 'OFFER_P2C_5_TITLE';
  static OFFER_P2C_5_DESC: string = 'OFFER_P2C_5_DESC';
  static OFFER_P2C_5_BUTTON: string = 'OFFER_P2C_5_BUTTON';
  static OFFER_P2S_TITLE: string = 'OFFER_P2S_TITLE';
  static OFFER_P2S_DESC: string = 'OFFER_P2S_DESC';
  static OFFER_P2S_BUTTON: string = 'OFFER_P2S_BUTTON';
  static OFFER_J2F_TITLE: string = 'OFFER_J2F_TITLE';
  static OFFER_J2F_DESC: string = 'OFFER_J2F_DESC';
  static OFFER_J2F_BUTTON: string = 'OFFER_J2F_BUTTON';
  static OFFER_J2F_S_TITLE: string = 'OFFER_J2F_S_TITLE';
  static OFFER_J2F_S_DESC: string = 'OFFER_J2F_S_DESC';
  static OFFER_J2F_S_BUTTON: string = 'OFFER_J2F_S_BUTTON';

  static PAYMENT_SUCCESSFUL_P2C_1_HEADER: string = 'PAYMENT_SUCCESSFUL_P2C_1_HEADER';
  static PAYMENT_SUCCESSFUL_P2C_1_TITLE: string = 'PAYMENT_SUCCESSFUL_P2C_1_TITLE';
  static PAYMENT_SUCCESSFUL_P2C_1_DESC: string = 'PAYMENT_SUCCESSFUL_P2C_1_DESC';
  static PAYMENT_SUCCESSFUL_P2C_2_HEADER: string = 'PAYMENT_SUCCESSFUL_P2C_2_HEADER';
  static PAYMENT_SUCCESSFUL_P2C_2_TITLE: string = 'PAYMENT_SUCCESSFUL_P2C_2_TITLE';
  static PAYMENT_SUCCESSFUL_P2C_2_DESC: string = 'PAYMENT_SUCCESSFUL_P2C_2_DESC';
  static PAYMENT_SUCCESSFUL_P2C_3_HEADER: string = 'PAYMENT_SUCCESSFUL_P2C_3_HEADER';
  static PAYMENT_SUCCESSFUL_P2C_3_TITLE: string = 'PAYMENT_SUCCESSFUL_P2C_3_TITLE';
  static PAYMENT_SUCCESSFUL_P2C_3_DESC: string = 'PAYMENT_SUCCESSFUL_P2C_3_DESC';
  static PAYMENT_SUCCESSFUL_P2C_4_HEADER: string = 'PAYMENT_SUCCESSFUL_P2C_4_HEADER';
  static PAYMENT_SUCCESSFUL_P2C_4_TITLE: string = 'PAYMENT_SUCCESSFUL_P2C_4_TITLE';
  static PAYMENT_SUCCESSFUL_P2C_4_DESC: string = 'PAYMENT_SUCCESSFUL_P2C_4_DESC';
  static PAYMENT_SUCCESSFUL_P2C_5_HEADER: string = 'PAYMENT_SUCCESSFUL_P2C_5_HEADER';
  static PAYMENT_SUCCESSFUL_P2C_5_TITLE: string = 'PAYMENT_SUCCESSFUL_P2C_5_TITLE';
  static PAYMENT_SUCCESSFUL_P2C_5_DESC: string = 'PAYMENT_SUCCESSFUL_P2C_5_DESC';
  static PAYMENT_SUCCESSFUL_P2S_HEADER: string = 'PAYMENT_SUCCESSFUL_P2S_HEADER';
  static PAYMENT_SUCCESSFUL_P2S_TITLE: string = 'PAYMENT_SUCCESSFUL_P2S_TITLE';
  static PAYMENT_SUCCESSFUL_P2S_DESC: string = 'PAYMENT_SUCCESSFUL_P2S_DESC';
  static PAYMENT_SUCCESSFUL_J2F_HEADER: string = 'PAYMENT_SUCCESSFUL_J2F_HEADER';
  static PAYMENT_SUCCESSFUL_J2F_TITLE: string = 'PAYMENT_SUCCESSFUL_J2F_TITLE';
  static PAYMENT_SUCCESSFUL_J2F_DESC: string = 'PAYMENT_SUCCESSFUL_J2F_DESC';
  static PAYMENT_SUCCESSFUL_J2F_S_HEADER: string = 'PAYMENT_SUCCESSFUL_J2F_S_HEADER';
  static PAYMENT_SUCCESSFUL_J2F_S_TITLE: string = 'PAYMENT_SUCCESSFUL_J2F_S_TITLE';
  static PAYMENT_SUCCESSFUL_J2F_S_DESC: string = 'PAYMENT_SUCCESSFUL_J2F_S_DESC';

  static INSUFFICIENT_FUNDS_TITLE = 'INSUFFICIENT_FUNDS_TITLE';
  static INSUFFICIENT_FUNDS_DESC = 'INSUFFICIENT_FUNDS_DESC';
  static INSUFFICIENT_FUNDS_BUTTON = 'INSUFFICIENT_FUNDS_BUTTON';
  static LIMIT_MESSAGE_TITLE = 'LIMIT_MESSAGE_TITLE';
  static LIMIT_MESSAGE_DESC = 'LIMIT_MESSAGE_DESC';
  static LIMIT_MESSAGE_BUTTON = 'LIMIT_MESSAGE_BUTTON';

  static GIVE_UP_HEADER: string = 'GIVE_UP_HEADER';
  static GIVE_UP_TITLE: string = 'GIVE_UP_TITLE';
  static GIVE_UP_DESC: string = 'GIVE_UP_DESC';
  static GIVE_UP_P2S_DESC: string = 'GIVE_UP_P2S_DESC';
  static GIVE_UP_P2S_BUTTON: string = 'GIVE_UP_P2S_BUTTON';
  static GIVE_UP_J2F_S_DESC: string = 'GIVE_UP_J2F_S_DESC';
  static GIVE_UP_J2F_S_BUTTON: string = 'GIVE_UP_J2F_S_BUTTON';

  static FINISH_GAME_HEADER: string = 'FINISH_GAME_HEADER';
  static FINISH_GAME_TITLE: string = 'FINISH_GAME_TITLE';
  static FINISH_GAME_DESC: string = 'FINISH_GAME_DESC';
  static FINISH_GAME_P2S_DESC: string = 'FINISH_GAME_P2S_DESC';
  static FINISH_GAME_P2S_BUTTON: string = 'FINISH_GAME_P2S_BUTTON';
  static FINISH_GAME_J2F_S_DESC: string = 'FINISH_GAME_J2F_S_DESC';
  static FINISH_GAME_J2F_S_BUTTON: string = 'FINISH_GAME_J2F_S_BUTTON';

  static WINNER_POPUP_TOP20_REWARD: string = 'WINNER_POPUP_TOP20_REWARD';
  static WINNER_POPUP_TOP20_TITLE: string = 'WINNER_POPUP_TOP20_TITLE';
  static WINNER_POPUP_TOP20_TEXT: string = 'WINNER_POPUP_TOP20_TEXT';
  static WINNER_POPUP_TOP20_BUTTON: string = 'WINNER_POPUP_TOP20_BUTTON';

  static WINNER_POPUP_TOP100_REWARD: string = 'WINNER_POPUP_TOP100_REWARD';
  static WINNER_POPUP_TOP100_TITLE: string = 'WINNER_POPUP_TOP100_TITLE';
  static WINNER_POPUP_TOP100_TEXT: string = 'WINNER_POPUP_TOP100_TEXT';
  static WINNER_POPUP_TOP100_BUTTON: string = 'WINNER_POPUP_TOP100_BUTTON';

  static LEADERBOARD_TITLE: string = 'LEADERBOARD_TITLE';

  static LIG_POPUP_HEADER: string = 'LIG_POPUP_HEADER';
  static LIG_POPUP_IMAGE: string = 'LIG_POPUP_IMAGE';
  static LIG_POPUP_DESC: string = 'LIG_POPUP_DESC';
  static LIG_POPUP_BUTTON: string = 'LIG_POPUP_BUTTON';

  static GENERAL_ERROR_TITLE: string = 'GENERAL_ERROR_TITLE';
  static GENERAL_ERROR_DESC: string = 'GENERAL_ERROR_DESC';
  static GENERAL_ERROR_RETRY_BUTTON: string = 'GENERAL_ERROR_RETRY_BUTTON';
  static GENERAL_ERROR_HOME_BUTTON: string = 'GENERAL_ERROR_HOME_BUTTON';

  // IMAGES
  static LOGO_IMAGE: string = 'LOGO_IMAGE';
  static PERSONAL_DATA_GAMER: string = 'PERSONAL_DATA_GAMER';
  static PERSONAL_DATA_LAST_MONTH: string = 'PERSONAL_DATA_LAST_MONTH';
  static PERSONAL_DATA_RANK: string = 'PERSONAL_DATA_RANK';
  static PERSONAL_DATA_SCORE: string = 'PERSONAL_DATA_SCORE';
  static PERSONAL_DATA_PRIZE: string = 'PERSONAL_DATA_PRIZE';
  static PERSONAL_DATA_CHECK: string = 'PERSONAL_DATA_CHECK';
  static MODAL_ICON_MY_ACCOUNT: string = 'MODAL_ICON_MY_ACCOUNT';
  static MODAL_ICON_PLAY: string = 'MODAL_ICON_PLAY';
  static MODAL_ICON_FAQ: string = 'MODAL_ICON_FAQ';
  static MODAL_ICON_ARE_YOU_SURE: string = 'MODAL_ICON_ARE_YOU_SURE';
  static TIME_EXPIRED_ICON: string = 'TIME_EXPIRED_ICON';
  static OFFER_ICON: string = 'OFFER_ICON';
  static MODAL_ICON_SMS_CODE: string = 'MODAL_ICON_SMS_CODE';
  static MODAL_ICON_WRONG_CODE: string = 'MODAL_ICON_WRONG_CODE';
  static MODAL_ICON_MOBILE_CONNECT: string = 'MODAL_ICON_MOBILE_CONNECT';
  static VIDEO_THUMBNAIL: string = 'VIDEO_THUMBNAIL';
  static ICON_ANSWER_CORRECT: string = 'ICON_ANSWER_CORRECT';
  static ICON_ANSWER_PRIZE: string = 'ICON_ANSWER_PRIZE';
  static ICON_OPPORTUNITY: string = 'ICON_OPPORTUNITY';
  static MODAL_ICON_SWEET_QUESTION: string = 'MODAL_ICON_SWEET_QUESTION';
  static CONFETTI: string = 'CONFETTI';
  static DRAWER_CLOSE: string = 'DRAWER_CLOSE';
  static DRAWER_MENU_ACCOUNT: string = 'DRAWER_MENU_ACCOUNT';
  static DRAWER_MENU_CONTACT: string = 'DRAWER_MENU_CONTACT';
  static DRAWER_MENU_FAQ: string = 'DRAWER_MENU_FAQ';
  static DRAWER_MENU_PLAY: string = 'DRAWER_MENU_PLAY';
  static DRAWER_MENU_SIGNOUT: string = 'DRAWER_MENU_SIGNOUT';
  static DRAWER_MENU_TERMS: string = 'DRAWER_MENU_TERMS';
  static DRAWER_MENU_OPEN: string = 'DRAWER_MENU_OPEN';
  static FOOTER_TURKCELL_LOGO: string = 'FOOTER_TURKCELL_LOGO';
  static FOOTER_YAANI_LOGO_TEXT: string = 'FOOTER_YAANI_LOGO_TEXT';
  static FOOTER_YAANI_LOGO: string = 'FOOTER_YAANI_LOGO';
  static ICON_BIP: string = 'ICON_BIP';
  static ICON_FB: string = 'ICON_FB';
  static ICON_TWITTER: string = 'ICON_TWITTER';
  static MODAL_ICON_ANSWER_WRONG: string = 'MODAL_ICON_ANSWER_WRONG';
  static MODAL_ICON_CLOSE: string = 'MODAL_ICON_CLOSE';
  static MODAL_ICON_CONGRATS: string = 'MODAL_ICON_CONGRATS';
  static MODAL_ICON_FREE_GAME: string = 'MODAL_ICON_FREE_GAME';
  static MODAL_ICON_INSUFFICIENT_FUND: string = 'MODAL_ICON_INSUFFICIENT_FUND';
  static MODAL_ICON_INTERNET: string = 'MODAL_ICON_INTERNET';
  static MODAL_WINNER_COINS: string = 'MODAL_WINNER_COINS';
  static MODAL_WINNER_STAR: string = 'MODAL_WINNER_STAR';
  static PRICE: string = 'PRICE';

  // VIDEO
  static VIDEO_MOBILE: string = 'VIDEO_MOBILE';
  static VIDEO_DESKTOP: string = 'VIDEO_DESKTOP';

  public static getFailModalKey(level: number, isHeader: boolean, isTimeout: boolean): string {
    if (isHeader) {
      if (isTimeout) {
        return `TIME_EXPIRED_LEVEL_${level}_HEADER`;
      } else {
        return `WRONG_ANSWER_LEVEL_${level}_HEADER`;
      }
    } else {
      if (isTimeout) {
        return `TIME_EXPIRED_LEVEL_${level}_DESC`;
      } else {
        return `WRONG_ANSWER_LEVEL_${level}_DESC`;
      }
    }
  }

  public static getOfferDescriptionKey(modal: ModalType, offer: OfferType, level: number, isTimeout?: boolean): string {
    if (modal === ModalType.NEW_GAME) {
      return `NEW_GAME_${offer}_DESC`;
    } else if (modal === ModalType.GIVE_UP) {
      return `GIVE_UP_${offer}_DESC`;
    } else if (modal === ModalType.CONGRATS) {
      return `FINISH_GAME_${offer}_DESC`;
    } else if (modal === ModalType.DECISION) {
      return `DESICION_${offer}_DESC`;
    } else if (modal === ModalType.FAIL) {
      if (isTimeout) {
        return `TIME_EXPIRED_LEVEL_${level}_${offer}_DESC`;
      } else {
        return `WRONG_ANSWER_LEVEL_${level}_${offer}_DESC`;
      }
    }
    return "Undefined offer state!";
  }

  public static getOfferTDRB(offer: OfferType, level?: number): OfferTDRB {
    if (level) {
      return {
        title: `OFFER_${offer}_${level}_TITLE`,
        description: `OFFER_${offer}_${level}_DESC`,
        reward: `OFFER_${offer}_${level}_REWARD`,
        button: `OFFER_${offer}_${level}_BUTTON`,
      }
    } else {
      return {
        title: `OFFER_${offer}_TITLE`,
        description: `OFFER_${offer}_DESC`,
        reward: `OFFER_${offer}_REWARD`,
        button: `OFFER_${offer}_BUTTON`,
      }
    }
  }

  public static getPaymentSuccessHRTD(offer: OfferType, level?: number): PaymentSuccessHRTD {
    if (level) {
      return {
        header: `PAYMENT_SUCCESSFUL_${offer}_${level}_HEADER`,
        reward: `PAYMENT_SUCCESSFUL_${offer}_${level}_REWARD`,
        title: `PAYMENT_SUCCESSFUL_${offer}_${level}_TITLE`,
        description: `PAYMENT_SUCCESSFUL_${offer}_${level}_DESC`,
      }
    } else {
      return {
        header: `PAYMENT_SUCCESSFUL_${offer}_HEADER`,
        reward: `PAYMENT_SUCCESSFUL_${offer}_REWARD`,
        title: `PAYMENT_SUCCESSFUL_${offer}_TITLE`,
        description: `PAYMENT_SUCCESSFUL_${offer}_DESC`,
      }
    }
  }

  public static getRewardKey(modal: ModalType): string {
    if (modal === ModalType.DECISION) {
      return "DESICION_REWARD";
    } else if (modal === ModalType.GIVE_UP) {
      return "GIVE_UP_REWARD";
    } else if (modal === ModalType.CONGRATS) {
      return "FINISH_GAME_REWARD";
    }
    return "Undefined prize state!";
  }

  public static getRewardKeyGiveUp(level: number): string {
    return `GIVE_UP_${level}_REWARD`;
  }
}
